<template>
  <div v-if="show" @click="$emit('update:show', false)"
    style="position: fixed; left: 0; top: 0; width: 100vw; background-color: rgba(255,255,255,.8); display: flex; justify-content: center; align-items: center; text-align: center; min-height: 100%;">
    <div class="modal-base p-8" style="border-radius: 30px; background-color: #FFF2DF; box-shadow: 0 0 8px 0px #0000004a; max-width: 1000px;">
      <div style="text-align: right; margin-bottom: 5px;"><font-awesome-icon size="2x" :icon="['fa', 'xmark']" @click="$emit('update:show', false)" /></div>
      <div @click="(e) => { e.stopPropagation() }"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['show']
}
</script>

<style>
.modal-base {
  /* margin-left: 50%; */
  /* transform: translateX(-50%); */
}
</style>